import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgBellSleeping = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 802",
					d: "M42.2793 15.2188C43.7459 15.6234 45.9458 16.2303 46.8625 16.4832L41.7869 20.5786C43.3668 20.811 46.6183 21.301 46.985 21.4021",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 803",
					d: "M43.2021 6.18164C44.165 6.31559 45.6094 6.51652 46.2112 6.60024L43.3278 9.68813C44.3484 9.70089 46.4499 9.73479 46.6906 9.76828",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 804",
					d: "M35.2633 2.48381C35.8442 2.41593 37.0685 2.20808 37.4315 2.16566L36.7902 5.39419C37.3863 5.24701 38.4708 5.04038 39.1784 4.79714",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "fill",
					d: "M19.9689 22.6084C20.8616 20.8231 24.751 19.3141 26.5841 18.7827C33.1994 17.6701 36.2176 21.8377 37.2697 22.9707C38.3218 24.1038 41.5186 31.5495 42.1256 33.2086C42.7326 34.8676 46.9815 39.7235 48.3573 40.371C49.458 40.8889 51.1052 43.8915 50.7675 43.9814C50.4667 44.0614 50.1058 43.9747 49.288 43.8915C46.9005 43.6487 39.7381 44.8222 37.8767 45.065C36.0153 45.3078 17.0095 49.2581 15.053 50.4245C13.4878 51.3576 13.5336 50.8133 13.7521 50.4245C13.885 49.8931 14.581 47.4117 16.3026 41.737C18.4546 34.6435 17.5778 32.9697 17.4981 29.8613C17.4184 26.7529 18.853 24.8401 19.9689 22.6084Z",
					fill: "#FFD000"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M29.873 50.1919C30.729 51.2602 31.4183 52.7617 31.2169 54.0481C31.0659 55.0075 30.1035 56.4796 30.1539 57.439C30.2294 58.9216 31.3005 60.0322 32.8864 60.6208C34.3717 61.1659 35.8167 61.5188 37.2517 60.8865C38.6866 60.2542 39.6558 58.8126 39.8069 57.439C39.9831 56.0436 39.1318 54.1315 37.7472 53.4338C36.9417 53.0195 36.179 53.3526 35.4489 52.8293C34.4923 52.1316 34.0257 50.0723 33.7488 49.0039",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M54.6858 47.4375C54.7944 44.5163 52.1637 40.4135 50.078 38.7662C47.4056 36.6356 45.6893 34.5051 44.1902 31.4082C41.3223 25.4559 39.2149 18.2737 32.3059 16.0553C28.8515 14.9571 25.0711 15.3305 21.8773 17.0437C18.6685 18.7966 13.6409 22.0126 14.5867 33.2256C15.0676 38.9276 11.9345 44.5721 11.2695 47.4627C10.6045 50.3534 9.57161 54.5909 10.1899 56.5145",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 790",
					d: "M30.652 27.2773C31.7767 27.8844 33.9024 28.5028 35.6747 26.9753",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 792",
					d: "M20.7694 29.6879C22.0189 29.9565 24.2327 29.9563 25.5076 27.9944",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M22.4838 16.1792C22.5779 13.8571 22.7281 12.0473 24.0697 11.5328C25.4112 11.0184 27.629 12.4848 27.4976 14.8199",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M41.7351 53.3752C47.5985 52.0494 51.8216 51.7174 54.7096 47.4749C52.7186 46.5979 50.7715 46.2104 48.8462 46.3531C36.8131 48.1684 22.7109 50.7595 14.552 53.3752C13.3049 53.9667 12.1054 54.6186 10.7618 55.6763C10.566 56.2667 9.70409 56.7626 11.2155 57.4692C17.0352 58.1014 20.5637 57.4069 26.4271 56.5911",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M54.5435 47.7557C54.4153 47.6911 54.1332 47.3434 53.4504 47.1664C52.7677 46.9894 52.6912 47.0314 51.981 46.916C51.9596 46.916 51.9383 46.916 51.9169 46.916C46.0019 46.9591 40.2149 48.0141 34.4707 49.3274C34.4921 49.4351 34.5134 49.5212 34.5561 49.6073C38.0155 49.715 41.4962 48.9829 44.9555 49.0906C45.4253 49.1121 45.8951 49.1337 46.4076 49.1767C47.6248 49.1552 49.9737 49.8011 50.0164 49.9733C50.6143 50.2317 51.1695 50.5547 51.6393 50.9637C52.4721 50.813 53.3323 50.085 53.8047 49.5621C54.2771 49.0391 55.2054 48.0787 54.5435 47.7557Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 534",
					cx: 29.7485,
					cy: 37.2465,
					r: 2.02386,
					fill: "#1B1B20"
				})
			]
		})
	})
});
export default SvgBellSleeping;
